const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const BaseModel = require('lib/base_model')
const template = require('./bubble.html')
const styles = require('./bubble.less')
const CssTemplate = require('./bubble.tcss')
const CssBehavior = require('behavior/css')
const Escape = require('lib/escape')
const radio = require('lib/radio')
const log = require('log').create('bubble') // eslint-disable-line
require('jquery-add-prefixed-class')
require('plugin/bounds')

let $bubbles
const NAV_HEIGHT = 70
const FADE_ALLOWANCE = 1000
const BOUNDS_TOLERANCE = 10

// map position strings to arrow direction strings
// these are only defaults; set options.arrow to whatever you want
const arrow_position_map = {
    'top': 'bottom',
    'bottom': 'top',
    'left': 'right',
    'right': 'left',
    'center': 'top',
}

const BubbleView = Marionette.View.extend({

    displayName: 'BubbleView',

    template,

    styles,

    ui: {
        content: '.message-content',
        close: '.bubble-close',
        title: '.bubble-title',
        arrow: '.bubble-arrow',
    },

    events: {
        'click @ui.close': 'dismiss',
    },

     
    constructor: function constructor(options) {
        // debugger
        this.options = options || {}
        this.bubble_id = _.uniqueId('bubble')
        this.initializeOptions()
        this.initializeRelativeOptions()
        this.initializeModel()
        Marionette.View.apply(this, arguments)
    },

    initialize() {
        this.bounds_check_counter = 0

        // bubbles render and show themselves when created
        this.render()
        this.show()
    },

    initializeOptions() {
        _.defaults(this.options, {
            close_button: true,
            close_tooltip: 'Close',
            close_on_escape: true,
            check_bounds: true,
            relativeTo: null,
            position: 'top',
            arrow: 'auto',
            arrow_distance: 20,
            offsetX: 0,
            offsetY: 0,
            title: null,
            viewClass: null,
            viewOptions: {},
            html: null,
            text: null,
        })
    },

    initializeRelativeOptions() {
        if (! this.options.relativeTo) return

        let relative = this.options.relativeTo

        if (relative instanceof Element) {
            // if a DOM element is passed in
            relative = $(relative)
        } else if (_.isString(relative)) {
            // if a string jquery selector is passed in
            relative = $(relative)
        }

        // relative should be a jquery object by now
        if (! (relative instanceof $)) {
            throw new Error('options.relativeTo must be a jquery object, DOM element, or jquery string selector')
        }

        if (! relative.length) {
            throw new Error('options.relativeTo doesn’t match any existing DOM nodes')
        }

        // save reference to $relative
        this.$relative = relative

    },

    initializeModel() {
        this.model = new BaseModel()
        this.model.set(this.options)
    },

    behaviors() {
        const behaviors = {}

        behaviors.Css = {
            behaviorClass: CssBehavior,
            label: `bubble-${this.bubble_id}`,
            template: CssTemplate,
            templateData: {
                bubble: this.model,
            },
            templateContext() {
                // log('templateContext')
                return {
                    id: this.bubble_id,
                }
            },
        }

        return behaviors
    },

    onRender() {
        this.addClassNames()

        if (this.options.viewClass) {
            this.addRegion('content', { el: this.ui.content })
            // eslint-disable-next-line new-cap
            this.view = new this.options.viewClass(this.options.viewOptions)
            this.listenTo(this.view, 'before:destroy', this.destroy)
            this.showChildView('content', this.view)

            // bind and delay region.empty and view.remove to allow fadeout time
            const content_region = this.getRegion('content')
            _.bindAll(content_region, 'empty')
            content_region.empty = _.debounce(content_region.empty, FADE_ALLOWANCE)
            _.bindAll(this.view, 'remove')
            this.view.remove = _.debounce(this.view.remove, FADE_ALLOWANCE)

        } else if (this.options.html) {
            this.ui.content.html(this.options.html)

        } else if (this.options.text) {
            this.ui.content.text(this.options.text)

        } else {
            throw new Error('Bubble requires a text or html string, or a view class.')
        }
    },

    addClassNames() {
        const classes = [
            'notification',
            'bubble',
            this.bubble_id,
        ]

        if (this.options.className) classes.push(this.options.className)

        this.$el.addClass(classes.join(' '))
    },

    show() {
        if (this.$relative) {
            this.addRelativeListeners()
            this.showNearElement()
        } else {
            this.showInBubbles()
        }

        this.triggerMethod('attach')

        if (this.view) {
            this.view.triggerMethod('attach')
        }

        this.fadeIn()

        if (this.options.close_on_escape) {
            Escape.listen(this.bubble_id, this.dismiss)
        }

    },

    showInBubbles() {
        // insert bubbles container if it doesn't exist
        if (! $bubbles || ! $bubbles.length) {
            $bubbles = $('<div class="bubbles"></div>')
            $.body.append($bubbles)
        }

        $bubbles.prepend(this.el)
    },

    showNearElement() {
        $.body.append(this.el)
        this.addPositionClass()
        this.addArrowClass()
        this.setRelativePosition()
    },

    addRelativeListeners() {
        // event listeners for relatively positioned bubble
        // listen for one window resize event
        $.window.one(`resize.${this.bubble_id}`, this.onWindowResize.bind(this))

        this.listenTo(this.model, 'change:position', this.addPositionClass)
        if (this.options.arrow === 'auto') {
            this.setAutoArrowType()
            this.listenTo(this.model, 'change:position', this.setAutoArrowType)
        }
        this.listenTo(this.model, 'change:arrow', this.addArrowClass)
        this.listenTo(this.model, 'change:position', this.setRelativePosition)
        this.on('reposition', this.setRelativePosition)
    },

    addPositionClass() {
        const position = this.model.get('position')
        if (position) {
            this.$el.addPrefixedClass('position', position)
        } else {
            this.$el.removePrefixedClass('position')
        }
    },

    setAutoArrowType() {
        // set value for options.arrow based on options.position
        // set options.arrow to some string to override this default
        // set options.arrow to false to disable the arrow
        const position = this.model.get('position')
        const arrow = arrow_position_map[position]
        if (arrow) this.model.set('arrow', arrow)
    },

    addArrowClass() {
        const arrow = this.model.get('arrow')
        if (arrow) {
            this.$el.addPrefixedClass('arrow', arrow)
        } else {
            this.$el.removePrefixedClass('arrow')
        }
    },

    setRelativePosition() {
        if (_.isFunction(this.options.adjustPosition)) {
            this.options.adjustPosition.call(this)
        } else {
            this.positionNearElement()
        }
        this.checkBounds()
        this.fadeIn()
    },

    positionNearElement() {
        let left
        let top

        const bubble = this.$el.bounds()
        const relative = this.$relative.bounds()

        const centerX = relative.left + (relative.width / 2) - (bubble.width / 2)
        const centerY = relative.top + (relative.height / 2) - (bubble.height / 2)

        const position = this.model.get('position')
        const arrow = this.model.get('arrow')
        const arrow_distance = this.model.get('arrow_distance')

        switch (position) {
            case 'top':
                left = centerX
                top = relative.top - bubble.height
                break
            case 'bottom':
                left = centerX
                top = relative.bottom
                break
            case 'left':
                left = relative.left - bubble.width
                top = centerY
                break
            case 'right':
                left = relative.right
                top = centerY
                break
            case 'center':
                left = centerX
                top = centerY
                break
            default:
                break
        }

        switch (arrow) {
            case 'top':
                top += arrow_distance
                break
            case 'bottom':
                top -= arrow_distance
                break
            case 'left':
                left += arrow_distance
                break
            case 'right':
                left -= arrow_distance
                break
            default:
                break
        }

        this.model.set({
            left,
            top,
        })

    },

    checkBounds() {
        if (! this.options.check_bounds) return

        const bubble = this.$el.bounds()
        const window_width = $.window.width()
        const window_height = $.window.height()
        const css = this.model.pick('position', 'left', 'top')

        // if clipped on same side as position, flip position to opposite side
        // else, adjust to be in bounds
        if (bubble.right > window_width) {
            if (css.position === 'right') {
                css.position = 'left'
            } else {
                css.left = window_width - bubble.width - BOUNDS_TOLERANCE
            }
        }
        if (bubble.left < 0) {
            if (css.position === 'left') {
                css.position = 'right'
            } else {
                css.left = BOUNDS_TOLERANCE
            }
        }
        if (bubble.bottom > window_height) {
            if (css.position === 'bottom') {
                css.position = 'top'
            } else {
                css.top = window_height - bubble.height - BOUNDS_TOLERANCE
            }
        }
        if (bubble.top < NAV_HEIGHT) {
            if (css.position === 'top') {
                css.position = 'bottom'
            } else {
                css.top = NAV_HEIGHT + 10
            }
        }

        this.model.set(css)
    },

    onWindowResize() {
        // when window resizes, hide bubble and wait for resize to stop
        this.fadeOut()
        this.listenToOnce(radio.viewport, 'window:resize', _.debounce(this.onWindowResizeStop, 2000))
    },
    onWindowResizeStop() {
        // if we were destroyed during window resize, no need to reposition
        if (this.isDestroyed()) return

        // when window is done resizing, reposition and reshow bubble
        this.setRelativePosition()

        // after positioning bubble, re-listen for one window resize event
        $.window.one(`resize.${this.bubble_id}`, this.onWindowResize.bind(this))
    },

    dismiss() {
        this.trigger('dismiss')
        this.destroy()
    },

    fadeIn() {
        _.defer(() => {
            this.$el.addPrefixedClass('fade', 'in')
        })
    },
    fadeOut() {
        _.defer(() => {
            this.$el.addPrefixedClass('fade', 'out')
        })
    },

    onBeforeDestroy() {
        // delay the remove method so the node stays in the DOM long enough for the fadeout to complete
        this.removeEl = _.debounce(this.removeEl, FADE_ALLOWANCE)

        // do the same for the behavior/css view
        _.bindAll(this.css, 'destroyCssView')
        this.css.destroyCssView = _.debounce(this.css.destroyCssView, FADE_ALLOWANCE)

        if (this.$relative) {
            this.fadeOut()
        } else {
            const bounds = this.$el.bounds()
            this.$el.height(bounds.height)
            this.fadeOut()
            _.defer(() => {
                this.$el.height(0)
            })
        }
        $.window.off(`resize.${this.bubble_id}`)
        if (_.isFunction(this.options.close)) {
            this.options.close.call(this)
        }
        if (this.options.close_on_escape) {
            Escape.unlisten(this.bubble_id)
        }
    },

})

module.exports = BubbleView
